import '../../../assets/css/adminComponentUi.min.css';

interface IButtonIcon {
    key?: number;
    children?: any;
    disabled?: boolean; 
    onClick?: Function;
    extraClass?: any;
}

export default (props: IButtonIcon) => {
    const { key, children, disabled, onClick, extraClass } = props; 
    return (
        <>
        <button
            key={key}
            onClick={() => {if (onClick) onClick()}}
            disabled={disabled ? disabled : false}
            className={`button-icon ${extraClass ? extraClass : ''}`}
        >
        {children}
        </button>
        </>
    );
}